import React from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  page: {
    minHeight: '100%',
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(4, 5, 6),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(3, 2, 5),
    },
  },
  header: {
    marginBottom: theme.spacing(3.5),
  },
  title: {
    fontSize: 28,
    fontWeight: 600,
    letterSpacing: '-0.01em',
    marginBottom: theme.spacing(0.5),
  },
  subtitle: {
    fontSize: 14,
    color: theme.palette.text.secondary,
    maxWidth: '62ch',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  headRow: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
  },
}));

/**
 * Shared frame for every non-map page. The map page (Live) opts out of this
 * deliberately — it needs the viewport edge-to-edge, so it manages its own
 * layout rather than sitting inside a padded document frame.
 */
const PageLayout = ({ title, subtitle, actions, children }) => {
  const classes = useStyles();
  return (
    <div className={classes.page}>
      <div className={classes.header}>
        <div className={classes.headRow}>
          <div>
            <Typography className={classes.title} component="h1">{title}</Typography>
            {subtitle && <div className={classes.subtitle}>{subtitle}</div>}
          </div>
          {actions && <div className={classes.actions}>{actions}</div>}
        </div>
      </div>
      {children}
    </div>
  );
};

export default PageLayout;
